import React from 'react';

const cx = (...c) => c.filter(Boolean).join(' ');

// Consistent max-width + horizontal padding wrapper.
const Container = ({ size = 'lg', className, children }) => {
  const max = size === 'sm' ? 'max-w-3xl' : size === 'md' ? 'max-w-5xl' : 'max-w-6xl';
  return (
    <div className={cx('mx-auto w-full px-4 sm:px-6', max, className)}>
      {children}
    </div>
  );
};

export default Container;
